import { ServiceManagementContainer } from "../../Componant/organisms/ServiceManagement";

type Props = {};

function ServiceManagement({}: Props) {
  return (
    <div className="page-body">
      <ServiceManagementContainer />
    </div>
  );
}

export default ServiceManagement;
